"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6147],{

/***/ 2422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ isIFrameWindow; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
function isIFrameWindow(windowObject) {
  if (!windowObject) return false;
  return windowObject.self !== windowObject.top;
}

/***/ }),

/***/ 6036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/constants.js + 1 modules
var constants = __webpack_require__(3705);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/aggregate/framework-detection.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const FRAMEWORKS = {
  REACT: 'React',
  NEXTJS: 'NextJS',
  VUE: 'Vue',
  NUXTJS: 'NuxtJS',
  ANGULAR: 'Angular',
  ANGULARUNIVERSAL: 'AngularUniversal',
  SVELTE: 'Svelte',
  SVELTEKIT: 'SvelteKit',
  PREACT: 'Preact',
  PREACTSSR: 'PreactSSR',
  ANGULARJS: 'AngularJS',
  BACKBONE: 'Backbone',
  EMBER: 'Ember',
  METEOR: 'Meteor',
  ZEPTO: 'Zepto',
  JQUERY: 'Jquery',
  MOOTOOLS: 'MooTools',
  QWIK: 'Qwik',
  ELECTRON: 'Electron'
};
function getFrameworks() {
  if (!runtime/* isBrowserScope */.il) return []; // don't bother detecting frameworks if not in the main window context

  const frameworks = [];
  try {
    if (detectReact()) {
      frameworks.push(FRAMEWORKS.REACT);
      if (detectNextJS()) frameworks.push(FRAMEWORKS.NEXTJS);
    }
    if (detectVue()) {
      frameworks.push(FRAMEWORKS.VUE);
      if (detectNuxtJS()) frameworks.push(FRAMEWORKS.NUXTJS);
    }
    if (detectAngular()) {
      frameworks.push(FRAMEWORKS.ANGULAR);
      if (detectAngularUniversal()) frameworks.push(FRAMEWORKS.ANGULARUNIVERSAL);
    }
    if (detectSvelte()) {
      frameworks.push(FRAMEWORKS.SVELTE);
      if (detectSvelteKit()) frameworks.push(FRAMEWORKS.SVELTEKIT);
    }
    if (detectPreact()) {
      frameworks.push(FRAMEWORKS.PREACT);
      if (detectPreactSSR()) frameworks.push(FRAMEWORKS.PREACTSSR);
    }
    if (detectAngularJs()) frameworks.push(FRAMEWORKS.ANGULARJS);
    if (Object.prototype.hasOwnProperty.call(window, 'Backbone')) frameworks.push(FRAMEWORKS.BACKBONE);
    if (Object.prototype.hasOwnProperty.call(window, 'Ember')) frameworks.push(FRAMEWORKS.EMBER);
    if (Object.prototype.hasOwnProperty.call(window, 'Meteor')) frameworks.push(FRAMEWORKS.METEOR);
    if (Object.prototype.hasOwnProperty.call(window, 'Zepto')) frameworks.push(FRAMEWORKS.ZEPTO);
    if (Object.prototype.hasOwnProperty.call(window, 'jQuery')) frameworks.push(FRAMEWORKS.JQUERY);
    if (Object.prototype.hasOwnProperty.call(window, 'MooTools')) frameworks.push(FRAMEWORKS.MOOTOOLS);
    if (Object.prototype.hasOwnProperty.call(window, 'qwikevents')) frameworks.push(FRAMEWORKS.QWIK);
    if (detectElectron()) frameworks.push(FRAMEWORKS.ELECTRON);
  } catch (err) {
    // Possibly not supported
  }
  return frameworks;
}
function detectReact() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'React') || Object.prototype.hasOwnProperty.call(window, 'ReactDOM') || Object.prototype.hasOwnProperty.call(window, 'ReactRedux') || document.querySelector('[data-reactroot], [data-reactid]') || (() => {
      const divs = document.querySelectorAll('body > div');
      for (let i = 0; i < divs.length; i++) {
        if (Object.prototype.hasOwnProperty.call(divs[i], '_reactRootContainer')) {
          return true;
        }
      }
    })();
  } catch (err) {
    return false;
  }
}
function detectNextJS() {
  // React SSR
  try {
    return Object.prototype.hasOwnProperty.call(window, 'next') && Object.prototype.hasOwnProperty.call(window.next, 'version');
  } catch (err) {
    return false;
  }
}
function detectVue() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'Vue');
  } catch (err) {
    return false;
  }
}
function detectNuxtJS() {
  // Vue SSR
  try {
    return Object.prototype.hasOwnProperty.call(window, '$nuxt') && Object.prototype.hasOwnProperty.call(window.$nuxt, 'nuxt');
  } catch (err) {
    return false;
  }
}
function detectAngular() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'ng') || document.querySelector('[ng-version]');
  } catch (err) {
    return false;
  }
}
function detectAngularUniversal() {
  // Anguler SSR
  try {
    return document.querySelector('[ng-server-context]');
  } catch (err) {
    return false;
  }
}
function detectSvelte() {
  try {
    return Object.prototype.hasOwnProperty.call(window, '__svelte');
  } catch (err) {
    return false;
  }
}
function detectSvelteKit() {
  // Svelte SSR
  try {
    return !!Object.keys(window).find(prop => prop.startsWith('__sveltekit'));
  } catch (err) {
    return false;
  }
}
function detectPreact() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'preact');
  } catch (err) {
    return false;
  }
}
function detectPreactSSR() {
  // Svelte SSR
  try {
    return document.querySelector('script[type="__PREACT_CLI_DATA__"]');
  } catch (err) {
    return false;
  }
}
function detectAngularJs() {
  try {
    return Object.prototype.hasOwnProperty.call(window, 'angular') || document.querySelector('.ng-binding, [ng-app], [data-ng-app], [ng-controller], [data-ng-controller], [ng-repeat], [data-ng-repeat]') || document.querySelector('script[src*="angular.js"], script[src*="angular.min.js"]');
  } catch (err) {
    return false;
  }
}
function detectElectron() {
  try {
    return typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0;
  } catch (err) {
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/protocol.js
var protocol = __webpack_require__(8584);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/load.js
var load = __webpack_require__(2277);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-listener/event-listener-opts.js
var event_listener_opts = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/dom/iframe.js
var iframe = __webpack_require__(2422);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */









// import { WEBSOCKET_TAG } from '../../../common/wrap/wrap-websocket'
// import { handleWebsocketEvents } from './websocket-detection'

class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t9;
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t9);
    this.harvestOpts.aggregatorTypes = ['cm', 'sm']; // the types in EventAggregator this feature cares about
    // This feature only harvests once per potential EoL of the page, which is handled by the central harvester.

    this.waitForFlags(['err']).then(([errFlag]) => {
      if (errFlag) {
        this.drain();
      } else {
        this.blocked = true; // if rum response determines that customer lacks entitlements for spa endpoint, this feature shouldn't harvest
        this.deregisterDrain();
      }
    });

    // Allow features external to the metrics feature to capture SMs and CMs through the event emitter
    (0,register_handler/* registerHandler */.X)(constants/* SUPPORTABILITY_METRIC_CHANNEL */.xS, this.storeSupportabilityMetrics.bind(this), this.featureName, this.ee);
    (0,register_handler/* registerHandler */.X)(constants/* CUSTOM_METRIC_CHANNEL */.vz, this.storeEventMetrics.bind(this), this.featureName, this.ee);
    this.singleChecks(); // checks that are run only one time, at script load
    this.eachSessionChecks(); // the start of every time user engages with page
  }
  preHarvestChecks(opts) {
    return this.drained && opts.isFinalHarvest;
  } // only allow any metrics to be sent after we get the right RUM flag and only on EoL

  storeSupportabilityMetrics(name, value) {
    if (this.blocked) return;
    const type = constants/* SUPPORTABILITY_METRIC */.mY;
    const params = {
      name
    };
    this.events.addMetric(type, name, params, value);
  }
  storeEventMetrics(name, metrics) {
    if (this.blocked) return;
    const type = constants/* CUSTOM_METRIC */.gF;
    const params = {
      name
    };
    this.events.add([type, name, params, metrics]);
  }
  singleChecks() {
    // report loaderType
    const {
      distMethod,
      loaderType
    } = this.agentRef.runtime;
    const {
      proxy,
      privacy
    } = this.agentRef.init;
    if (loaderType) this.storeSupportabilityMetrics("Generic/LoaderType/".concat(loaderType, "/Detected"));
    if (distMethod) this.storeSupportabilityMetrics("Generic/DistMethod/".concat(distMethod, "/Detected"));
    if (runtime/* isBrowserScope */.il) {
      this.storeSupportabilityMetrics('Generic/Runtime/Browser/Detected');
      const nonce = document?.currentScript?.nonce;
      if (nonce && nonce !== '') {
        this.storeSupportabilityMetrics('Generic/Runtime/Nonce/Detected');
      }

      // These SMs are used by the AppExp team
      (0,load/* onDOMContentLoaded */.KB)(() => {
        getFrameworks().forEach(framework => {
          this.storeSupportabilityMetrics('Framework/' + framework + '/Detected');
        });
      });
      if (!privacy.cookies_enabled) this.storeSupportabilityMetrics('Config/SessionTracking/Disabled');
    } else if (runtime/* isWorkerScope */.v6) {
      this.storeSupportabilityMetrics('Generic/Runtime/Worker/Detected');
    } else {
      this.storeSupportabilityMetrics('Generic/Runtime/Unknown/Detected');
    }

    // Track if the agent is being loaded using a file protocol such as is the case in some
    // set-top box applications or Electron applications
    if ((0,protocol/* isFileProtocol */.V)()) {
      this.storeSupportabilityMetrics('Generic/FileProtocol/Detected');
    }

    // Capture SMs to assess customer engagement with the obfuscation config
    if (this.obfuscator.obfuscateConfigRules.length > 0) {
      this.storeSupportabilityMetrics('Generic/Obfuscate/Detected');
    }

    // Check if proxy for either chunks or beacon is being used
    if (proxy.assets) this.storeSupportabilityMetrics('Config/AssetsUrl/Changed');
    if (proxy.beacon) this.storeSupportabilityMetrics('Config/BeaconUrl/Changed');
    if (runtime/* isBrowserScope */.il && window.MutationObserver) {
      if ((0,iframe/* isIFrameWindow */.u)(window)) {
        this.storeSupportabilityMetrics('Generic/Runtime/IFrame/Detected');
      }
      const preExistingVideos = window.document.querySelectorAll('video').length;
      if (preExistingVideos) this.storeSupportabilityMetrics('Generic/VideoElement/Added', preExistingVideos);
      const preExistingIframes = window.document.querySelectorAll('iframe').length;
      if (preExistingIframes) this.storeSupportabilityMetrics('Generic/IFrame/Added', preExistingIframes);
      const mo = new MutationObserver(records => {
        records.forEach(record => {
          record.addedNodes.forEach(addedNode => {
            if (addedNode instanceof HTMLVideoElement) {
              this.storeSupportabilityMetrics('Generic/VideoElement/Added', 1);
            }
            if (addedNode instanceof HTMLIFrameElement) {
              this.storeSupportabilityMetrics('Generic/IFrame/Added', 1);
            }
          });
        });
      });
      mo.observe(window.document.body, {
        childList: true,
        subtree: true
      });
    }

    // webdriver detection
    if (navigator.webdriver) this.storeSupportabilityMetrics('Generic/WebDriver/Detected');

    // WATCHABLE_WEB_SOCKET_EVENTS.forEach(tag => {
    //   registerHandler('buffered-' + WEBSOCKET_TAG + tag, (...args) => {
    //     handleWebsocketEvents(this.storeSupportabilityMetrics.bind(this), tag, ...args)
    //   }, this.featureName, this.ee)
    // })
  }
  eachSessionChecks() {
    if (!runtime/* isBrowserScope */.il) return;

    // [Temporary] Report restores from BFCache to NR1 while feature flag is in place in lieu of sending pageshow events.
    (0,event_listener_opts/* windowAddEventListener */.bP)('pageshow', evt => {
      if (evt?.persisted) {
        this.storeSupportabilityMetrics('Generic/BFCache/PageRestored');
      }
    });
  }
}

/***/ })

}]);